function base64EncArr (aBytes) {
  var eqLen = (3 - (aBytes.length % 3)) % 3,
    codeAry = []

  for (
      var nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0;
      nIdx < nLen;
      nIdx++
    ) {
    nMod3 = nIdx % 3
      /* Uncomment the following line in order to split the output in lines 76-character long: */
      /*
    if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
    */
    nUint24 |= aBytes[nIdx] << ((16 >>> nMod3) & 24)
    if (nMod3 === 2 || aBytes.length - nIdx === 1) {
      codeAry.push(
          (nUint24 >>> 18) & 63,
          (nUint24 >>> 12) & 63,
          (nUint24 >>> 6) & 63,
          nUint24 & 63
        )
      nUint24 = 0
    }
  }

  if (eqLen === 0) return Uint8Array.from(codeAry)

  const b64ChartCode = codeAry.slice(0, codeAry.length - eqLen)
  if (eqLen === 1) {
    b64ChartCode.push(128)
  } else {
    b64ChartCode.push(128, 128)
  }

  return Uint8Array.from(b64ChartCode)
}

function strToUTF8Arr (sDOMStr) {
  var aBytes,
    nChr,
    nStrLen = sDOMStr.length,
    nArrLen = 0

    /* mapping... */

  for (var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
    nChr = sDOMStr.charCodeAt(nMapIdx)
    nArrLen +=
        nChr < 0x80
          ? 1
          : nChr < 0x800
          ? 2
          : nChr < 0x10000
          ? 3
          : nChr < 0x200000
          ? 4
          : nChr < 0x4000000
          ? 5
          : 6
  }

  aBytes = new Uint8Array(nArrLen)

    /* transcription... */

  for (var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
    nChr = sDOMStr.charCodeAt(nChrIdx)
    if (nChr < 128) {
        /* one byte */
      aBytes[nIdx++] = nChr
    } else if (nChr < 0x800) {
        /* two bytes */
      aBytes[nIdx++] = 192 + (nChr >>> 6)
      aBytes[nIdx++] = 128 + (nChr & 63)
    } else if (nChr < 0x10000) {
        /* three bytes */
      aBytes[nIdx++] = 224 + (nChr >>> 12)
      aBytes[nIdx++] = 128 + ((nChr >>> 6) & 63)
      aBytes[nIdx++] = 128 + (nChr & 63)
    } else if (nChr < 0x200000) {
        /* four bytes */
      aBytes[nIdx++] = 240 + (nChr >>> 18)
      aBytes[nIdx++] = 128 + ((nChr >>> 12) & 63)
      aBytes[nIdx++] = 128 + ((nChr >>> 6) & 63)
      aBytes[nIdx++] = 128 + (nChr & 63)
    } else if (nChr < 0x4000000) {
        /* five bytes */
      aBytes[nIdx++] = 248 + (nChr >>> 24)
      aBytes[nIdx++] = 128 + ((nChr >>> 18) & 63)
      aBytes[nIdx++] = 128 + ((nChr >>> 12) & 63)
      aBytes[nIdx++] = 128 + ((nChr >>> 6) & 63)
      aBytes[nIdx++] = 128 + (nChr & 63)
    } /* if (nChr <= 0x7fffffff) */ else {
        /* six bytes */
      aBytes[nIdx++] = 252 + (nChr >>> 30)
      aBytes[nIdx++] = 128 + ((nChr >>> 24) & 63)
      aBytes[nIdx++] = 128 + ((nChr >>> 18) & 63)
      aBytes[nIdx++] = 128 + ((nChr >>> 12) & 63)
      aBytes[nIdx++] = 128 + ((nChr >>> 6) & 63)
      aBytes[nIdx++] = 128 + (nChr & 63)
    }
  }

  return aBytes
}

export {
    base64EncArr,
    strToUTF8Arr
  }



// WEBPACK FOOTER //
// ./src/views/index/modules/baseFn.js